import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography, TextLink } from '@ellucian/react-design-system/core';

interface InstallConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onDone: () => void;
}

const InstallConfirmationDialog: React.FC<InstallConfirmationDialogProps> = ({ open, onClose, onDone }) => {
    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={(event: any, reason: string) => {
                // Only allow closing via the title bar close button
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                handleClose();
            }}
            disableEscapeKeyDown
            showTitleBarClose={true}
            maxWidth={false}
            PaperProps={{
                sx: {
                    display: 'flex',
                    width: { xs: 'calc(100% - 32px)', sm: '648px' },
                    maxWidth: { xs: 'calc(100% - 32px)', sm: '648px' },
                    borderRadius: '4px',
                    boxShadow: '0px 8px 32px 0px rgba(0,0,0,0.16)',
                    flexDirection: 'column',
                    background: '#fff',
                    p: { xs: '16px', sm: '24px' },
                    margin: { xs: '16px', sm: 'auto' },
                    position: 'relative',
                }
            }}
            BackdropProps={{
                sx: {
                    background: 'rgba(0, 0, 0, 0.30) !important',
                }
            }}
        >
            {/* <DialogTitle
                sx={{
                    fontWeight: 700,
                    fontSize: 22,
                    lineHeight: '28px',
                    pb: 0,
                    pt: '32px',
                    px: '32px',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: 'block',
                    textAlign: 'left',
                }}
            >
                Installation Confirmed
            </DialogTitle> */}

            <Box sx={{ mb: 3, mt: 0, ml: 0, mr: 0, textAlign: 'left', width: '100%' }}>
                <Typography
                    variant="h2"
                    sx={{
                        color: 'var(--Neutral-neutral-600, #151618)',
                        fontFamily: 'Poppins, Futura, Century Gothic, Arial, sans-serif',
                        fontSize: '24px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '110%', // 26.4px
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        m: 0,
                        p: 0,
                    }}
                >
                    Request Submitted
                </Typography>
            </Box>
            <DialogContent sx={{ p: 0, textAlign: 'center' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        alignSelf: 'stretch',
                        minHeight: '80px',
                        padding: '6px',
                        gap: '6px',
                        background: 'var(--Neutral-neutral-100, #fff)',
                        boxSizing: 'border-box',
                        mb: 6,
                    }}
                >
                    <Box sx={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
                        <img
                            src={require('../../icons/success.svg').default}
                            alt="Success"
                            style={{ width: 60, height: 60, display: 'block' }}
                        />
                    </Box>
                    <Typography
                        variant="h4"
                        sx={{
                            color: 'var(--Neutral-neutral-600, #151618)',
                            textAlign: 'center',
                            fontFamily: '"Proxima Nova", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            lineHeight: '125%', // 20px
                            letterSpacing: '0.08px',
                            mb: 0,
                        }}
                    >
                        Your request for information has been submitted.
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'var(--Neutral-neutral-500, #5B5E65)',
                            textAlign: 'center',
                            fontFamily: '"Proxima Nova", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            lineHeight: '125%', // 17.5px
                            letterSpacing: '0.07px',
                            mb: 0,
                        }}
                    >
                        An Ellucian or Partner representative will reach out to you regarding this solution and provide next steps.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'flex-end', px: '16px', pb: '6px', pt: 0 }}>
                <Button
                    color="secondary"
                    onClick={onDone}
                    sx={{
                        color: 'var(--Interactive-Blue-cta-blue-600, #026BC8)',
                        fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '110%',
                        textTransform: 'capitalize'
                    }}
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InstallConfirmationDialog;
